<div role="alert" [ngClass]="{'hidden':!shown}" [class]="alertClass" class="admin-alert alert alert-sm alert-dismissible fade in">
    <button type="button" class="close" (click)="close()">
        <span aria-hidden="true">&times;</span><span class="sr-only">Close</span>
    </button>
    <div>
        <span [class]="iconClass" class="vismaicon vismaicon-filled"></span>
        <span>{{text}}</span>
    </div>
</div>